import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import UploadPage from './components/UploadPage';
import NotFound from './components/NotFound';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/:requestId" element={<UploadPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
